<!-- side menu bar for web view -->
<ion-content class="content-web-section web-nav-wrap">
  <div class="nav-menu-wrap">
    <div class="side-nav-header">
      <img src="assets/images/on-boarding/logo_ITI.png" alt="ITI-logo" class="iti-logo">
    </div>
    <ng-template [ngIf]="investFlow !== 'quickInvest'">
      <div *ngFor ="let item of menuItems" >
      <div class="side-nav-item" *ngIf="!item?.disabled" [ngClass]="{'active' : activeMainTab === item.activeTab}"
        (click)="setActiveTab(item); ">
          <div class="side-nav-highlight"></div>
          <div class="side-nav-item-icon">
            <img src={{item.icon}}>
          </div>
          <div class="side-nav-item-text">
            {{item.displayName}}
          </div>
        <div class="collapsable-icon" *ngIf="item.isChildren">
          <img src="assets/images/menu-icons/web-menu/plus.png" *ngIf="!item.isExpand">
          <img src="assets/images/menu-icons/web-menu/minus.png" *ngIf="item.isExpand">
        </div>
      </div>
    </div>
  </ng-template>
<!-- </div> -->
  <ng-template [ngIf]="investFlow === 'quickInvest'">
    <div class="side-nav-item" *ngFor = "let item of transactItems" [ngClass]="{'active' : activeInvestMode === item.transactName}"
      (click)="transactRoute(item) ">
        <div class="side-nav-highlight"></div>
        <div class="side-nav-item-icon">
          <img src="{{item.icon}}">
        </div>
        <div class="side-nav-item-text">
          {{item.transactName}}
        </div>
    </div>
  </ng-template>
  </div>
</ion-content>

<!-- navigation bottom drawer for mobile view -->
<ion-bottom-drawer class="content-mobile-section more-drawer" *ngIf="toggleMoreTab && investFlow !== 'quickInvest'" [minimumHeight]=0
  [dockedHeight]=50 [shouldBounce]=true [distanceTop]=0 >
  <div class="handle" (click)="closeBottomDrawer()"></div>
  <div class="more-items-container">
    <div class="header-wrap">
      <div>
        <img src="assets/images/investor-dashboard/Notification.png" class="notification-icon">
      </div>
      <div>
        <img src="{{profilePicture}}" *ngIf="profilePicture && !profilePicture.includes('image/null')" alt="userSessionInfo?.name"
        class="profile-pic" />

      <div class="initials-container" *ngIf="(!profilePicture || profilePicture.includes('image/null')) && initials">
        {{initials}}
      </div>
      </div>
      <div class="text-wrap">
        <div class="header-text align-h">
          <div>
            <p>Hello, {{userSessionInfo?.name  | titlecase}}</p>
            <p *ngIf="userSessionInfo?.lastLogin?.length > 0" class="header-subtext"> 
              Last login: {{userSessionInfo?.lastLogin | date: 'dd MMM yyyy'}} | {{userSessionInfo?.lastLogin | date:  'h:mm a'}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    
     <ng-template ngFor let-item [ngForOf]="menuItemsForMoreTab">
      <div class="more-item-wrap" *ngIf="!item?.disabled && item?.displayName != 'New fund offer'" (click)="setActiveTabForMore(item)">
        <div [ngClass]="{'active-more-highlight' : activeTabForMore === item.activeTab}"></div>
          <div class="more-item">
            <div class="more-item-icon">
              <img src={{item.icon}}>
            </div>
            <div class="more-item-text" [ngClass]="{'active-more' : activeTabForMore === item.activeTab}">
              {{item.displayName}}
            </div>
          </div>
      </div>

     <div class="more-item-wrap" *ngIf="!item?.disabled && item?.displayName == 'New fund offer'">
      <div [ngClass]="{'active-more-highlight' : activeTabForMore === item.activeTab}"></div>
        <div class="more-item" (click)="setActiveTabAndCollapsable(item)">
          <div class="more-item-icon">
            <img src={{item.icon}}>
          </div>
          <div class="more-item-text" [ngClass]="{'active-more' : activeTabForMore === item.activeTab}">
            {{item.displayName}}
          </div>
        </div>
        <div class="collapsable-icon-for-mobile margin-left-10" (menuOpened)="menuOpened(item)" (menuClosed)="menuClosed()" [matMenuTriggerFor]="investNow"> 
          <img src="assets/images/menu-icons/web-menu/plus.png" *ngIf="!newfundSubMenuIsExpand">
          <img src="assets/images/menu-icons/web-menu/minus.png" *ngIf="newfundSubMenuIsExpand">
        </div>
     </div>
    </ng-template>
<!-- Expand menu -->
    <mat-menu #investNow="matMenu" xPosition="after">
      <button mat-menu-item (click)="routeToSip()">
        <span>Start a SIP</span>
      </button>
      <button mat-menu-item (click)="routeToLumpsum()">
        <span>Invest lumpsum</span>
      </button>
    </mat-menu>
  </div>
</ion-bottom-drawer>

<!-- footer for mobile view -->
<ion-toolbar class="footer-menu-wrap content-mobile-section" *ngIf="investFlow !== 'quickInvest'">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col *ngFor="let item of menuItemsinMobileFooter" (click)="setActiveTab(item)">
        <div class="menu-icon-mobile">
          <img src={{item.icon}} *ngIf="activeMainTab !== item.activeTab">
          <img src={{item.activeIcon}} *ngIf="activeMainTab === item.activeTab">
        </div>
        <div class="menu-text-mobile" [ngClass]="{'active-mobile' : activeMainTab === item.activeTab}">
          {{item.displayName}}
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>